import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Receipt } from "@/components/Receipt";
import { buildReceiptModel } from "@/lib/receipt";
import { BrandMark } from "@/components/AppShell";

export default function PublicReceipt() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { api.get(`/public/receipt/${token}`).then((r) => setData(r.data)).catch(() => setMissing(true)); }, [token]);
  return (
    <div className="grain min-h-[100dvh] bg-slate-950 px-4 py-8" data-testid="public-receipt-page">
      <div className="mx-auto max-w-md">
        <div className="mb-5 flex justify-center"><BrandMark /></div>
        <div className="rounded-2xl bg-white py-4 shadow-2xl">
          {data && <Receipt model={buildReceiptModel(data.sale, data.biz)} />}
          {!data && !missing && <div className="flex justify-center py-16 text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>}
          {missing && <p className="px-6 py-16 text-center text-sm font-semibold text-slate-600" data-testid="public-receipt-missing">This receipt link isn't valid.</p>}
        </div>
      </div>
    </div>
  );
}
